export default {
  color: 'purple',
  eContent: {
    link: 'connect',
    label: 'Connect with us'
  },
}
